module.exports = __webpack_public_path__ + "static/smartphone-743af3aa1f298d25006e85229b773139.jpg";